import React, { useEffect, useState } from "react";

import { ComboBox, FormSection } from "../../../components";

import { Fazenda, Raca } from "../../../types";

interface ConsultaInterface {
  Fazenda?: number;
  Raca?: number;
}

interface FormPesquisaFiltroAvancadoProps {
  fazendas: Fazenda[];
  racas: Raca[];
  handleConsulta: any;
  onRacaSelected: any;
}

const FormPesquisaFiltroAvancado: React.FC<FormPesquisaFiltroAvancadoProps> = ({
  fazendas,
  racas,
  handleConsulta,
  onRacaSelected,
}) => {
  const [consulta, setConsulta] = useState<ConsultaInterface>({});
  const [inputDropdownFazenda, setInputDropdownFazenda] = useState<string>("");
  const [inputDropdownRaca, setInputDropdownRaca] = useState<string>("");

  const handleInputFazenda = (value: Fazenda) => {
    setInputDropdownFazenda(value.nomeFantasia);
    setConsulta({ ...consulta, Fazenda: value.idFazenda });
  };

  const handleInputRaca = (value: Raca) => {
    setInputDropdownRaca(value.nome);
    onRacaSelected(value);
    setConsulta({ ...consulta, Raca: value.id });
  };

  useEffect(() => {
    handleConsulta(consulta);
  }, [consulta]);

  return (
    <div className="main-content">
      <FormSection title="Pesquisa por Filtro Avançado" borderBottomWidth={287}>
        <ComboBox
          value={inputDropdownFazenda}
          items={fazendas}
          displayName="nomeFantasia"
          placeholder="Fazenda"
          handleInput={handleInputFazenda}
        />

        <ComboBox
          value={inputDropdownRaca}
          items={racas}
          placeholder="Raça"
          displayName="nome"
          handleInput={handleInputRaca}
        />
      </FormSection>
    </div>
  );
};

export default FormPesquisaFiltroAvancado;
